import { Injectable } from '@angular/core';
// import { SwUpdate } from '@angular/service-worker';

import { BehaviorSubject, timer } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UpdateServiceWorkerService {
  newVersionAvailable$ = new BehaviorSubject(false);

  constructor() {}
}
